export const convertToWeeklyRate = (pricingRate: any): number => {
  return (
    Math.ceil((pricingRate.price * 7) / pricingRate.thresholdDuration / 1000) *
    1000
  )
}
